export default {"src":"/_next/static/media/Help.78f917a2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};